// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__WADcF","loader_full":"style_loader_full__RmnAV","lottieLoader":"style_lottieLoader__Gx79n"};